
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import CourseBtn from '@xt/www/components/courseBtn/index.vue'
import { Observer } from 'mobx-vue'
import { EnumProductType } from '@xt/client/enums/product'
import { courseBan } from '@xt/client/utils/course/ban'
import { OriginProductItem } from '@xt/client/entities/product-v2/types'

@Observer
@Component({
  components: {
    CourseBtn,
    LazyImg
  }
})
export default class ComCard extends Mixins(MixinsHomeClick) {
  @Prop() dataSource: OriginProductItem

  get isGroup() {
    return this.dataSource.activityType === 1
  }
  get tips() {
    return this.PageStore.getTipLabel(this.dataSource.contentType)
  }
  get infoText() {
    return this.PageStore.mapInfoText(this.dataSource)
  }
  get PageStore() {
    return this.$store.$productV2
  }
  get btnConfig() {
    return this.PageStore.mapCourseButton(this.dataSource)
  }

  async handleClick() {
    // 检测课程是否在ban列表中，如果在ban列表中则直接toast "课程已结束"
    const isBan = await courseBan.isBan(this.dataSource.id)

    if (isBan) {
      this.$msg('课程已结束')
      return
    }

    this.commonToDetail()
  }

  commonToDetail(): void {
    switch (this.dataSource.productType) {
      case EnumProductType.dayCourse:
      case EnumProductType.selfStudy:
        this.toDayCourseDetail()
        return
      case EnumProductType.fullstage:
        this.toLiveCourseDetail()
        return
      case EnumProductType.single:
        this.toLiveCourseDetail()
        return
      case EnumProductType.offlineExhibition:
        this.toExhibitionDetail()
        return
      case EnumProductType.onlineExhibition:
        this.toExhibitionDetail()
        return
      default:
      // 异常
    }
  }

  toExhibitionDetail() {
    window.open(`/commodity/${this.dataSource.id.toString()}`)
  }

  toLiveCourseDetail() {
    if (this.dataSource.activityPageUrl) return window.open(this.dataSource.activityPageUrl)
    window.open(`/commodity/${this.dataSource.id.toString()}`)
  }

  toDayCourseDetail() {
    window.open(`/commodity/${this.dataSource.id.toString()}`)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
